import * as React from 'react';
import { Button, Input, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Messages } from 'utils';

interface IProps {
    open: boolean;
    password?: string | null;
    username?: string;
    title: string;
    description: string;
    onCancel: () => void;
}

const ApiAccessGeneratedPasswordModal: React.FC<IProps> = ({
    open,
    password,
    username,
    title,
    description,
    onCancel,
}) => {
    const passwordValue = password || '';

    const handleCopy = React.useCallback(() => {
        if (!passwordValue) {
            return;
        }

        navigator.clipboard.writeText(passwordValue);
        Messages.success('Copied to clipboard');
    }, [passwordValue]);

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            destroyOnClose
            centered
            width={680}
            closeIcon={<CloseOutlined className="text-gray-400" />}
            className="top-6"
            classNames={{
                content: '!rounded-2xl !p-0',
                header: '!hidden',
                body: '!p-0',
            }}
        >
            <div className="px-7 pb-6 pt-5">
                <div className="mb-1 text-xs uppercase tracking-[0.12em] text-gray-400">
                    API Access
                </div>
                <div className="mb-2 text-[22px] font-semibold text-gray-900">{title}</div>
                <div className="mb-5 text-sm text-gray-500">{description}</div>

                <div className="rounded-2xl border border-gray-200 bg-[#fcfcfd] p-5">
                    {username ? (
                        <div className="mb-4 text-sm text-gray-400">User: {username}</div>
                    ) : null}
                    <div className="grid grid-cols-1 gap-4 md:grid-cols-[minmax(0,1fr)_auto]">
                        <div>
                            <div className="mb-2 text-sm font-medium text-gray-900">Password</div>
                            <Input value={passwordValue} readOnly />
                        </div>
                        <div className="flex md:h-full md:items-end">
                            <Button
                                shape="round"
                                className="!h-10 !rounded-full !px-[18px]"
                                onClick={handleCopy}
                                disabled={!passwordValue}
                            >
                                Copy
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="mt-5 flex justify-end">
                    <Button
                        type="primary"
                        shape="round"
                        onClick={onCancel}
                        className="!border-0 !bg-[#df1f26] !shadow-none hover:!bg-[#c91b21] focus:!bg-[#c91b21]"
                    >
                        Close
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ApiAccessGeneratedPasswordModal;
